/* Shop pillar grid (sections/shop-pillar.liquid): filters, the film tile, card swipe.
   While the 2026 pillar section is on the page, assets/pillar.js runs all of this (and "Your matches" from the
   stool finder), so this file stands down. Without it, the grid works on its own. */
(function () {
  if (window.__shopPillar) return;
  window.__shopPillar = true;

  function init() {
    if (document.querySelector('[data-plr] [data-plr-data]')) return; /* pillar.js owns the grid */
    var sec = document.querySelector('[data-shop-pillar]');
    if (!sec) return;
    var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };
    var grid = sec.querySelector('[data-plr-grid]');
    var cards = grid ? $$('[data-card]', grid) : [], tiles = grid ? $$('[data-tile]', grid) : [];
    var chips = $$('[data-filter]', sec), countEl = sec.querySelector('[data-plr-count]');
    var countTpl = countEl ? countEl.textContent.replace(/\d+/, '%n') : '%n';
    function ev(name, p) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p || {})); }

    var FILTERS = {
      all: function () { return true; },
      oak: function (c) { return c.dataset.mat === 'oak'; }, steel: function (c) { return c.dataset.mat === 'steel'; },
      back: function (c) { return c.dataset.back && c.dataset.back !== 'none'; }, backless: function (c) { return c.dataset.back === 'none'; },
      arms: function (c) { return c.dataset.back === 'arms'; }
    };
    var FIELD = { material: 'mat' };
    chips.forEach(function (c) {
      var fd = c.dataset.field, eq = c.dataset.eq;
      if (fd) FILTERS[c.dataset.filter] = function (card) { return card.getAttribute('data-' + (FIELD[fd] || fd)) === eq; };
    });
    function setFilter(k, silent) {
      if (!FILTERS[k]) k = 'all';
      var n = 0;
      cards.forEach(function (c) { var on = FILTERS[k](c); c.hidden = !on; if (on) n++; });
      tiles.forEach(function (t) { t.hidden = k !== 'all'; });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.filter === k)); });
      if (countEl) countEl.textContent = countTpl.replace('%n', n);
      var url = new URL(location.href);
      if (k === 'all') url.searchParams.delete('filter'); else url.searchParams.set('filter', k);
      history.replaceState(history.state, '', url);
      if (!silent) ev('pillar_filter', { key: k, count: n });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { setFilter(c.dataset.filter); }); });
    var q = new URLSearchParams(location.search).get('filter');
    if (q) setFilter(q, true);

    /* Card image swipe: the colour squares fade once past the packshot */
    $$('.plr-card__track[data-plr-swipe]', sec).forEach(function (t) {
      var card = t.closest('.plr-card');
      t.addEventListener('scroll', function () { card.classList.toggle('is-swiped', t.scrollLeft > t.clientWidth * 0.25); }, { passive: true });
    });

    /* Film: the cut for the box's shape, loaded near the viewport, played only while visible; reduced motion keeps the poster */
    var vids = $$('[data-plr-video]', sec);
    if (vids.length && 'IntersectionObserver' in window) {
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches, wide = window.matchMedia('(min-width:768px)');
      vids.forEach(function (v) {
        var land = v.clientWidth >= v.clientHeight, key = land || wide.matches ? 'd' : 'm';
        var pst = v.getAttribute('data-poster-' + key); if (pst) v.poster = pst;
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              if (!v.src) v.src = v.getAttribute('data-src-' + key);
              if (!still) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            } else if (!v.paused) v.pause();
          });
        }, { rootMargin: '200px 0px' }).observe(v);
      });
    }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
